<template>
  <div class="appointment-freight-all-orders">
    <el-card class="box-card" shadow="never">
      
      <!-- 搜索条件 -->
      <div class="search-toolbar">
        <el-form :inline="true" size="small" class="search-form">
          <el-form-item label="投保人">
            <el-input v-model="searchForm.policyholder" placeholder="投保人" style="width: 200px;" clearable />
          </el-form-item>

          <el-form-item label="被保险人">
            <el-input v-model="searchForm.beneficiary" placeholder="被保险人" style="width: 200px;" clearable />
          </el-form-item>

          <el-form-item label="手机号">
            <el-input v-model="searchForm.mobile" placeholder="手机号码" style="width: 140px;" clearable />
          </el-form-item>

          <el-form-item label="保单号">
            <el-input v-model="searchForm.policyNo" placeholder="保单号" style="width: 200px;" clearable />
          </el-form-item>

          <el-form-item label="运单号">
            <el-input v-model="searchForm.trackNo" placeholder="运单号" style="width: 140px;" clearable />
          </el-form-item>

          <el-form-item label="价格方案">
            <el-input v-model="searchForm.priceName" placeholder="价格方案" style="width: 180px;" clearable />
          </el-form-item>

          <el-form-item label="大保单号">
            <el-input v-model="searchForm.generalPolicyNo" placeholder="大保单号" style="width: 200px;" clearable />
          </el-form-item>

          <el-form-item label="平台单号">
            <el-input v-model="searchForm.seqNo" placeholder="平台单号" style="width: 200px;" clearable />
          </el-form-item>

          <el-form-item label="渠道商">
            <el-autocomplete
              v-model="searchForm.channelName"
              :fetch-suggestions="queryChannel"
              placeholder="渠道商"
              clearable
              style="width: 220px;"
              @input="handleChannelInput"
              @select="handleChannelSelect"
            >
              <template slot-scope="{ item }">
                <div>{{ item.name || item.realname }}<span v-if="item.alias"> ({{ item.alias }})</span></div>
              </template>
            </el-autocomplete>
          </el-form-item>

          <el-form-item label="投保时间">
            <el-date-picker
              v-model="searchForm.beginTime"
              type="date"
              placeholder="开始时间"
              style="width: 140px;"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
            <span style="margin: 0 8px;">至</span>
            <el-date-picker
              v-model="searchForm.endTime"
              type="date"
              placeholder="结束时间"
              style="width: 140px;"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>

          <el-form-item label="生效时间">
            <el-date-picker
              v-model="searchForm.effectedTime"
              type="date"
              placeholder="生效时间"
              style="width: 110px;"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
            <span style="margin: 0 8px;">至</span>
            <el-date-picker
              v-model="searchForm.expiredTime"
              type="date"
              placeholder="失效时间"
              style="width: 110px;"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>

          <el-form-item label="起始地">
            <el-input v-model="searchForm.beginning" placeholder="起始地" style="width: 140px;" clearable />
          </el-form-item>

          <el-form-item label="目的地">
            <el-input v-model="searchForm.destination" placeholder="目的地" style="width: 140px;" clearable />
          </el-form-item>

          <el-form-item label="投保状态">
            <el-select v-model="searchForm.status" placeholder="投保状态" style="width: 100px;" clearable>
              <el-option label="未支付" value="1" />
              <el-option label="已支付" value="4" />
              <el-option label="已取消" value="66" />
            </el-select>
          </el-form-item>

          <el-form-item v-if="!isDongHaiRole" label="保险公司">
            <el-select
              v-model="searchForm.insuranceType"
              filterable
              clearable
              placeholder="保险公司类型"
              style="width: 220px;"
            >
              <el-option
                v-for="item in insuranceCompanyList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>

          <div class="search-actions">
            <div class="search-buttons">
              <el-button type="primary" @click="handleSearch">搜索</el-button>
              <el-button @click="handleReset">重置</el-button>
            </div>
            <div class="search-summary">
              <span class="premium-total">
                <strong>保费总额：<span style="color:#ff7300">{{ premiumTotal }}</span>元</strong>
              </span>
              <el-button type="success" icon="el-icon-download" @click="handleExport">导出Excel</el-button>
            </div>
          </div>
        </el-form>
      </div>
      
      <!-- 数据表格 -->
      <el-table
        :data="tableData"
        v-loading="loading"
        border
        stripe
        style="width: 100%"
        :height="tableHeight"
      >
        <el-table-column prop="policyholder" label="投保人" width="270" align="center" />
        <el-table-column prop="beneficiary" label="被保险人" width="270" align="center" />
        <el-table-column prop="mobile" label="手机号" width="100" align="center" />
        <el-table-column prop="price_name" label="价格方案" width="170" align="center" />
        <el-table-column prop="insurance_type" label="保险公司类型" width="150" align="center">
          <template slot-scope="scope">
            {{ formatInsuranceType(scope.row.insurance_type) }}
          </template>
        </el-table-column>
        <el-table-column prop="policy_no" label="保单号" width="180" align="center" />
        <el-table-column prop="general_policy_no" label="大保单号" width="180" align="center" />
        <el-table-column label="查看详情" width="80" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleViewDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="track_no" label="运单号" width="100" align="center" />
        <el-table-column prop="plate_no" label="车牌号" width="150" align="center" />
        <el-table-column prop="plate_extra_no" label="挂车车牌号" width="150" align="center" />
        <el-table-column prop="vin_no" label="车架号" width="150" align="center" />
        <el-table-column prop="cargo_name" label="货物名称" width="100" align="center" />
        <el-table-column prop="cargo_type" label="货物类型" width="80" align="center" />
        <el-table-column prop="quantity" label="货物数量" width="80" align="center" />
        <el-table-column prop="beginning" label="起始地" width="260" align="center" />
        <el-table-column prop="destination" label="目的地" width="260" align="center" />
        <el-table-column prop="carriage" label="运费(元)" width="80" align="center">
          <template slot-scope="scope">
            {{ formatMoney(scope.row.carriage/100) }}
          </template>
        </el-table-column>
        <el-table-column prop="coverage" label="保额(元)" width="80" align="center" />
        <el-table-column prop="price" label="价格(元)" width="80" align="center">
          <template slot-scope="scope">
            {{ formatMoney(scope.row.price/100) }}
          </template>
        </el-table-column>
        <el-table-column prop="pay_price" label="实际付款(元)" width="120" align="center">
          <template slot-scope="scope">
            {{ formatMoney(scope.row.pay_price/100) }}
          </template>
        </el-table-column>
        <el-table-column prop="pay_type" label="支付方式" width="100" align="center">
          <template slot-scope="scope">
            {{ formatPayType(scope.row.pay_type) }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="订单状态" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="invoice_status" label="发票状态" width="90" align="center">
          <template slot-scope="scope">
            {{ formatInvoiceStatus(scope.row.invoice_status) }}
          </template>
        </el-table-column>
        <el-table-column prop="channel_name" label="订单渠道" width="150" align="center" />
        <el-table-column prop="source" label="订单来源" width="110" align="center">
          <template slot-scope="scope">
            {{ formatOrderSource(scope.row.source) }}
          </template>
        </el-table-column>
        <el-table-column prop="note" label="出单描述" width="150" align="center" />
        <el-table-column prop="additional_info_preserved" label="备注" width="150" align="center" />
        <el-table-column prop="created_at" label="投保时间" width="140" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column prop="effected_at" label="生效时间" width="140" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.effected_at) }}
          </template>
        </el-table-column>
        <el-table-column prop="expired_at" label="到期时间" width="140" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.expired_at) }}
          </template>
        </el-table-column>
        <el-table-column prop="updated_at" label="更新时间" width="140" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.updated_at) }}
          </template>
        </el-table-column>
        <el-table-column prop="seq_no" label="平台单号" width="180" align="center" />
        <el-table-column label="操作" width="90" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleEdit(scope.row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pager.page"
          :page-sizes="[10, 15, 20, 25]"
          :page-size="pager.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pager.total"
        />
      </div>
    </el-card>
    
    <!-- 详情对话框 -->
    <el-dialog
      title="订单详情"
      :visible.sync="detailDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <div v-if="currentOrder" class="order-detail-content">
        <table class="detail-table">
          <tr>
            <td class="label">投保人：</td>
            <td class="value">{{ currentOrder.policyholder }}</td>
            <td class="label">被保险人：</td>
            <td class="value">{{ currentOrder.beneficiary }}</td>
          </tr>
          <tr>
            <td class="label">手机号：</td>
            <td class="value">{{ currentOrder.mobile }}</td>
            <td class="label">价格方案：</td>
            <td class="value">{{ currentOrder.price_name }}</td>
          </tr>
          <tr>
            <td class="label">保险公司类型：</td>
            <td class="value">{{ formatInsuranceType(currentOrder.insurance_type) }}</td>
            <td class="label">保单号：</td>
            <td class="value highlight">{{ currentOrder.policy_no }}</td>
          </tr>
          <tr>
            <td class="label">大保单号：</td>
            <td class="value">{{ currentOrder.general_policy_no }}</td>
            <td class="label">运单号：</td>
            <td class="value highlight">{{ currentOrder.track_no }}</td>
          </tr>
          <tr>
            <td class="label">车牌号：</td>
            <td class="value">{{ currentOrder.plate_no }}</td>
            <td class="label">挂车车牌号：</td>
            <td class="value">{{ currentOrder.plate_extra_no }}</td>
          </tr>
          <tr>
            <td class="label">车架号：</td>
            <td class="value">{{ currentOrder.vin_no }}</td>
            <td class="label">货物名称：</td>
            <td class="value">{{ currentOrder.cargo_name }}</td>
          </tr>
          <tr>
            <td class="label">货物类型：</td>
            <td class="value">{{ currentOrder.cargo_type }}</td>
            <td class="label">货物数量：</td>
            <td class="value">{{ currentOrder.quantity }}</td>
          </tr>
          <tr>
            <td class="label">起始地：</td>
            <td class="value">{{ currentOrder.beginning }}</td>
            <td class="label">目的地：</td>
            <td class="value">{{ currentOrder.destination }}</td>
          </tr>
          <tr>
            <td class="label">运费：</td>
            <td class="value price">{{ formatMoney(currentOrder.carriage/100) }}元</td>
            <td class="label">保额：</td>
            <td class="value price">{{ currentOrder.coverage }}元</td>
          </tr>
          <tr>
            <td class="label">价格：</td>
            <td class="value price">{{ formatMoney(currentOrder.price/100) }}元</td>
            <td class="label">实际付款：</td>
            <td class="value price highlight">{{ formatMoney(currentOrder.pay_price/100) }}元</td>
          </tr>
          <tr>
            <td class="label">支付方式：</td>
            <td class="value">{{ formatPayType(currentOrder.pay_type) }}</td>
            <td class="label">订单状态：</td>
            <td class="value">
              <span class="status-tag" :class="getStatusType(currentOrder.status)">{{ getStatusText(currentOrder.status) }}</span>
            </td>
          </tr>
          <tr>
            <td class="label">发票状态：</td>
            <td class="value">{{ formatInvoiceStatus(currentOrder.invoice_status) }}</td>
            <td class="label">订单渠道：</td>
            <td class="value">{{ currentOrder.channel_name }}</td>
          </tr>
          <tr>
            <td class="label">订单来源：</td>
            <td class="value">{{ formatOrderSource(currentOrder.source) }}</td>
            <td class="label">平台单号：</td>
            <td class="value">{{ currentOrder.seq_no }}</td>
          </tr>
          <tr>
            <td class="label">投保时间：</td>
            <td class="value">{{ formatDate(currentOrder.created_at) }}</td>
            <td class="label">生效时间：</td>
            <td class="value">{{ formatDate(currentOrder.effected_at) }}</td>
          </tr>
          <tr>
            <td class="label">到期时间：</td>
            <td class="value">{{ formatDate(currentOrder.expired_at) }}</td>
            <td class="label">更新时间：</td>
            <td class="value">{{ formatDate(currentOrder.updated_at) }}</td>
          </tr>
          <tr>
            <td class="label">电子保单：</td>
            <td class="value">
              <span v-if="currentOrder.status < 4" class="no-policy">暂无保单</span>
              <a v-else-if="currentOrder.policy_url" 
                 :href="currentOrder.policy_url" 
                 target="_blank" 
                 class="policy-link">
                下载保单
              </a>
              <a v-else-if="needApiPolicy(currentOrder.insurance_type)" 
                 @click="downloadPolicy(currentOrder.id, currentOrder.insurance_type)" 
                 class="policy-link">
                下载保单
              </a>
              <span v-else class="no-policy">暂无保单</span>
            </td>
            <td class="label">出单描述：</td>
            <td class="value">{{ currentOrder.note || '无' }}</td>
          </tr>
          <tr>
            <td class="label">备注：</td>
            <td class="value">{{ currentOrder.additional_info_preserved || '无' }}</td>
            <td class="label">订单文件：</td>
            <td class="value">
              <div
                v-for="(fileUrl, index) in getOrderFiles(currentOrder.file_url)"
                :key="`${fileUrl}-${index}`"
                class="order-file-item"
              >
                <span class="order-file-name">{{ getFileName(fileUrl, index) }}</span>
                <a
                  :href="fileUrl"
                  :download="getFileName(fileUrl, index)"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="policy-link"
                >下载</a>
              </div>
              <span v-if="getOrderFiles(currentOrder.file_url).length === 0" class="no-policy">无</span>
            </td>
          </tr>
        </table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false" size="medium">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 订单修订对话框 -->
    <el-dialog
      title="订单信息修改"
      :visible.sync="editDialogVisible"
      width="900px"
      :close-on-click-modal="false"
      @closed="resetEditForm"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :rules="editRules"
        label-width="100px"
        size="small"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="投保人" prop="policyholder">
              <el-input v-model="editForm.policyholder" maxlength="128" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="被保险人" prop="beneficiary">
              <el-input v-model="editForm.beneficiary" maxlength="128" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="运单号" prop="track_no">
              <el-input v-model="editForm.track_no" maxlength="64" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车牌号" prop="plate_no">
              <el-input v-model="editForm.plate_no" maxlength="32" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="货物名称" prop="cargo_name">
              <el-input v-model="editForm.cargo_name" maxlength="64" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="货物数量" prop="quantity">
              <el-input v-model="editForm.quantity" maxlength="64" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="起始地" prop="beginning">
              <el-input v-model="editForm.beginning" maxlength="255" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="目的地" prop="destination">
              <el-input v-model="editForm.destination" maxlength="255" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="投保时间" prop="created_at">
              <el-date-picker
                v-model="editForm.created_at"
                type="datetime"
                value-format="timestamp"
                placeholder="请选择投保时间"
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生效时间" prop="effected_at">
              <el-date-picker
                v-model="editForm.effected_at"
                type="datetime"
                value-format="timestamp"
                placeholder="请选择生效时间"
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="到期时间" prop="expired_at">
              <el-date-picker
                v-model="editForm.expired_at"
                type="datetime"
                value-format="timestamp"
                placeholder="请选择到期时间"
                style="width:100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="editSubmitting" @click="submitEdit">保存并报备</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getHyxOrderList, getHyxOrderInfo, deleteHyxOrder, reviseHyxOrder } from '@/api/hyx-order'
import { getInsuranceCompanyList } from '@/api/claim'
import { getChannelList } from '@/api/member'
import { getToken } from '@/lib/local'

const createSearchForm = () => ({
  policyholder: '',
  beneficiary: '',
  mobile: '',
  policyNo: '',
  trackNo: '',
  beginTime: '',
  endTime: '',
  effectedTime: '',
  expiredTime: '',
  status: '',
  priceName: '',
  beginning: '',
  destination: '',
  insuranceType: '',
  generalPolicyNo: '',
  seqNo: '',
  channelName: ''
})

const createEditForm = () => ({
  id: 0,
  policyholder: '',
  beneficiary: '',
  track_no: '',
  plate_no: '',
  cargo_name: '',
  quantity: '',
  beginning: '',
  destination: '',
  created_at: null,
  effected_at: null,
  expired_at: null
})

export default {
  name: 'AppointmentFreightAllOrders',
  data() {
    return {
      loading: false,
      searchForm: createSearchForm(),
      tableData: [],
      pager: {
        page: 1,
        size: 15,
        total: 0
      },
      detailDialogVisible: false,
      currentOrder: null,
      editDialogVisible: false,
      editSubmitting: false,
      editForm: createEditForm(),
      editRules: {
        policyholder: [{ required: true, message: '请输入投保人', trigger: 'blur' }],
        beneficiary: [{ required: true, message: '请输入被保险人', trigger: 'blur' }],
        created_at: [{ required: true, message: '请选择投保时间', trigger: 'change' }],
        effected_at: [{ required: true, message: '请选择生效时间', trigger: 'change' }],
        expired_at: [{ required: true, message: '请选择到期时间', trigger: 'change' }]
      },
      premiumTotal: '0.00',
      tableHeight: 600,
      insuranceCompanyList: [],
      channelList: [],
      selectedChannel: null
    }
  },
  computed: {
    roleId() {
      return Number(this.$store.state.user.type || getToken('admin_role') || 0)
    },
    isDongHaiRole() {
      return this.roleId === 10
    }
  },
  mounted() {
    this.loadData()
    this.fetchInsuranceCompanyList()
    this.fetchChannelList()
    this.calculateTableHeight()
    window.addEventListener('resize', this.calculateTableHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateTableHeight)
  },
  methods: {
    calculateTableHeight() {
      // 计算表格高度，适应屏幕
      const windowHeight = window.innerHeight
      this.tableHeight = windowHeight - 350
    },
    async fetchInsuranceCompanyList() {
      try {
        const res = await getInsuranceCompanyList({ type: 1 })
        this.insuranceCompanyList = res.rows || []
      } catch (error) {
        console.error('获取保险公司列表失败:', error)
      }
    },
    async fetchChannelList() {
      try {
        const res = await getChannelList()
        this.channelList = (res.rows || []).map(item => ({
          ...item,
          value: item.name || item.realname || item.alias || ''
        }))
      } catch (e) {
        // ignore
      }
    },
    queryChannel(queryString, cb) {
      const results = queryString
        ? this.channelList.filter(item => {
            const name = (item.name || item.realname || '').toLowerCase()
            const alias = (item.alias || '').toLowerCase()
            const q = queryString.toLowerCase()
            return name.includes(q) || alias.includes(q)
          })
        : this.channelList
      cb(results)
    },
    handleChannelSelect(item) {
      this.selectedChannel = item
    },
    handleChannelInput(value) {
      if (this.selectedChannel && value !== this.selectedChannel.value) {
        this.selectedChannel = null
      }
    },
    resolveChannel() {
      if (!this.searchForm.channelName) return null
      if (
        this.selectedChannel &&
        this.selectedChannel.value === this.searchForm.channelName
      ) {
        return this.selectedChannel
      }
      return this.channelList.find(
        item =>
          item.value === this.searchForm.channelName ||
          item.alias === this.searchForm.channelName
      )
    },
    getDayTimestamp(value, endOfDay = false) {
      if (!value) return 0
      const time = endOfDay ? '23:59:59' : '00:00:00'
      const date = new Date(`${value}T${time}`)
      return isNaN(date.getTime()) ? 0 : Math.floor(date.getTime() / 1000)
    },
    buildSearchParams() {
      const params = {}
      const form = this.searchForm

      if (form.policyholder) params.policyholder = form.policyholder
      if (form.beneficiary) params.beneficiary = form.beneficiary
      if (form.mobile) params.mobile = form.mobile
      if (form.policyNo) params.policy_no = form.policyNo
      if (form.trackNo) params.track_no = form.trackNo
      if (form.status) params.status = form.status
      if (form.priceName) params.price_name = form.priceName
      if (form.beginning) params.beginning = form.beginning
      if (form.destination) params.destination = form.destination
      if (form.insuranceType !== '') params.insurance_type = form.insuranceType
      if (form.generalPolicyNo) params.general_policy_no = form.generalPolicyNo
      if (form.seqNo) params.seq_no = form.seqNo

      const beginDate = this.getDayTimestamp(form.beginTime)
      const endDate = this.getDayTimestamp(form.endTime, true)
      const effectedAt = this.getDayTimestamp(form.effectedTime)
      const expiredAt = this.getDayTimestamp(form.expiredTime, true)
      if (beginDate) params.begin_date = beginDate
      if (endDate) params.end_date = endDate
      if (effectedAt) params.effected_at = effectedAt
      if (expiredAt) params.expired_at = expiredAt

      const channel = this.resolveChannel()
      if (channel) params.channel_id = channel.id

      return params
    },
    async loadData() {
      this.loading = true
      try {
        const params = {
          ...this.buildSearchParams(),
          page: this.pager.page,
          rows: this.pager.size,
          platform_type: 8
        }

        // 东海角色只能查看保险公司类型为 255 的订单，任何搜索条件下都必须携带该参数
        if (this.isDongHaiRole) {
          params.insurance_type = 255
        }
        
        // 调用API获取订单列表
        const response = await getHyxOrderList(params)
        if (response && response.err_code === 0) {
          this.tableData = response.rows ? response.rows : []
          this.pager.total = response.total ? response.total : 0
          this.premiumTotal = response.sum ? (response.sum /100).toFixed(2) : 0
        } else {
          this.$message.error('获取数据失败：' + (response.data && response.data.message ? response.data.message : '未知错误'))
          this.tableData = []
          this.pager.total = 0
          this.premiumTotal = '0.00'
        }
      } catch (error) {
        console.error('加载数据失败：', error)
        this.$message.error('加载数据失败：' + error.message)
        this.tableData = []
        this.pager.total = 0
        this.premiumTotal = '0.00'
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      if (this.searchForm.channelName && !this.resolveChannel()) {
        this.$message.warning('请从渠道商下拉列表中选择渠道')
        return
      }
      this.pager.page = 1
      this.loadData()
    },
    handleReset() {
      this.searchForm = createSearchForm()
      this.selectedChannel = null
      this.pager.page = 1
      this.loadData()
    },
    async handleExport() {
      if (this.searchForm.channelName && !this.resolveChannel()) {
        this.$message.warning('请从渠道商下拉列表中选择渠道')
        return
      }
      try {
        this.$message.info('正在导出，请稍候...')

        // 导出仅携带当前搜索条件，不携带分页参数，由后端返回全部匹配数据。
        const params = {
          ...this.buildSearchParams(),
          platform_type: 8
        }
        if (this.isDongHaiRole) {
          params.insurance_type = 255
        }
        const response = await getHyxOrderList(params)
        if (!response || response.err_code !== 0) {
          throw new Error('获取导出数据失败')
        }
        const rows = response.rows || []
        
        // 定义导出的表头配置
        const headers = [
          { title: '投保人', key: 'policyholder' },
          { title: '被保险人', key: 'beneficiary' },
          { title: '手机号', key: 'mobile' },
          { title: '价格方案', key: 'price_name' },
          { title: '保险公司类型', key: 'insurance_type' },
          { title: '保单号', key: 'policy_no' },
          { title: '大保单号', key: 'general_policy_no' },
          { title: '运单号', key: 'track_no' },
          { title: '车牌号', key: 'plate_no' },
          { title: '挂车车牌号', key: 'plate_extra_no' },
          { title: '车架号', key: 'vin_no' },
          { title: '货物名称', key: 'cargo_name' },
          { title: '货物类型', key: 'cargo_type' },
          { title: '货物数量', key: 'quantity' },
          { title: '起始地', key: 'beginning' },
          { title: '目的地', key: 'destination' },
          { title: '运费(元)', key: 'carriage' },
          { title: '保额(元)', key: 'coverage' },
          { title: '价格(元)', key: 'price' },
          { title: '实际付款(元)', key: 'pay_price' },
          { title: '支付方式', key: 'pay_type' },
          { title: '订单状态', key: 'status' },
          { title: '发票状态', key: 'invoice_status' },
          { title: '订单渠道', key: 'channel_name' },
          { title: '订单来源', key: 'source' },
          { title: '出单描述', key: 'note' },
          { title: '备注', key: 'additional_info_preserved' },
          { title: '投保时间', key: 'created_at' },
          { title: '生效时间', key: 'effected_at' },
          { title: '到期时间', key: 'expired_at' },
          { title: '更新时间', key: 'updated_at' },
          { title: '平台单号', key: 'seq_no' }
        ]
        
        // 格式化导出数据
        const exportData = rows.map(item => ({
          policyholder: item.policyholder,
          beneficiary: item.beneficiary,
          mobile: item.mobile,
          price_name: item.price_name,
          insurance_type: this.formatInsuranceType(item.insurance_type),
          policy_no: item.policy_no,
          general_policy_no: item.general_policy_no,
          track_no: item.track_no,
          plate_no: item.plate_no,
          plate_extra_no: item.plate_extra_no,
          vin_no: item.vin_no,
          cargo_name: item.cargo_name,
          cargo_type: item.cargo_type,
          quantity: item.quantity,
          beginning: item.beginning,
          destination: item.destination,
          carriage: this.formatMoney(Number(item.carriage || 0) / 100),
          coverage: item.coverage,
          price: this.formatMoney(Number(item.price || 0) / 100),
          pay_price: this.formatMoney(Number(item.pay_price || 0) / 100),
          pay_type: this.formatPayType(item.pay_type),
          status: this.getStatusText(item.status),
          invoice_status: this.formatInvoiceStatus(item.invoice_status),
          channel_name: item.channel_name,
          source: this.formatOrderSource(item.source),
          note: item.note,
          additional_info_preserved: item.additional_info_preserved,
          created_at: this.formatDate(item.created_at),
          effected_at: this.formatDate(item.effected_at),
          expired_at: this.formatDate(item.expired_at),
          updated_at: this.formatDate(item.updated_at),
          seq_no: item.seq_no
        }))
        
        // 生成CSV内容
        const csvContent = this.generateCSV(exportData, headers)
        
        // 生成文件名
        const now = new Date()
        const dateStr = now.getFullYear() + 
          String(now.getMonth() + 1).padStart(2, '0') + 
          String(now.getDate()).padStart(2, '0')
        const fileName = `预约货运险订单列表_${dateStr}.csv`
        
        // 下载文件
        this.downloadCSV(csvContent, fileName)
        
        this.$message.success('导出成功')
      } catch (error) {
        console.error('导出Excel失败:', error)
        this.$message.error('导出失败，请重试')
      }
    },
    
    generateCSV(data, headers) {
      // 生成CSV格式的字符串
      const headerRow = headers.map(h => h.title).join(',')
      const dataRows = data.map(row => {
        return headers.map(h => {
          const value = row[h.key] || ''
          // 处理包含逗号或换行符的值
          return `"${String(value).replace(/"/g, '""')}"`
        }).join(',')
      })
      
      return '\uFEFF' + [headerRow, ...dataRows].join('\n')
    },
    
    downloadCSV(content, filename) {
      // 创建Blob对象
      const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' })
      
      // 创建下载链接
      const link = document.createElement('a')
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob)
        link.setAttribute('href', url)
        link.setAttribute('download', filename)
        link.style.visibility = 'hidden'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    },
    handleSizeChange(size) {
      this.pager.size = size
      this.loadData()
    },
    handleCurrentChange(page) {
      this.pager.page = page
      this.loadData()
    },
    async handleViewDetail(row) {
      try {
        this.loading = true
        
        // 调用API获取详细信息
        const response = await getHyxOrderInfo({ id: row.id })
        
        if (response.data && response.err_code === 0) {
          this.currentOrder = response.data || row
          this.detailDialogVisible = true
        } else {
          this.$message.error('获取详情失败：' + (response.data && response.data.message ? response.data.message : '未知错误'))
          // 如果API失败，使用当前行数据
          this.currentOrder = { ...row }
          this.detailDialogVisible = true
        }
      } catch (error) {
        console.error('获取详情失败：', error)
        this.$message.error('获取详情失败：' + error.message)
        // 如果API失败，使用当前行数据
        this.currentOrder = { ...row }
        this.detailDialogVisible = true
      } finally {
        this.loading = false
      }
    },
    toMilliseconds(value) {
      if (value === undefined || value === null || value === '') return null
      if (typeof value === 'number') {
        return value < 10000000000 ? value * 1000 : value
      }
      if (typeof value === 'string' && /^\d+$/.test(value)) {
        const timestamp = Number(value)
        return timestamp < 10000000000 ? timestamp * 1000 : timestamp
      }
      const timestamp = new Date(value).getTime()
      return Number.isNaN(timestamp) ? null : timestamp
    },
    async handleEdit(row) {
      this.loading = true
      try {
        const response = await getHyxOrderInfo({ id: row.id })
        const order = response && response.err_code === 0 && response.data
          ? response.data
          : row
        this.editForm = {
          id: order.id,
          policyholder: order.policyholder || '',
          beneficiary: order.beneficiary || '',
          track_no: order.track_no || '',
          plate_no: order.plate_no || '',
          cargo_name: order.cargo_name || '',
          quantity: order.quantity || '',
          beginning: order.beginning || '',
          destination: order.destination || '',
          created_at: this.toMilliseconds(order.created_at),
          effected_at: this.toMilliseconds(order.effected_at),
          expired_at: this.toMilliseconds(order.expired_at)
        }
        this.editDialogVisible = true
      } catch (error) {
        console.error('获取订单信息失败：', error)
        this.$message.error('获取订单信息失败')
      } finally {
        this.loading = false
      }
    },
    resetEditForm() {
      this.editForm = createEditForm()
      if (this.$refs.editForm) {
        this.$refs.editForm.clearValidate()
      }
    },
    submitEdit() {
      this.$refs.editForm.validate(async valid => {
        if (!valid) return
        if (this.editForm.expired_at < this.editForm.effected_at) {
          this.$message.warning('到期时间不能早于生效时间')
          return
        }
        if (this.editForm.expired_at < this.editForm.created_at) {
          this.$message.warning('到期时间不能早于投保时间')
          return
        }

        this.editSubmitting = true
        try {
          const response = await reviseHyxOrder({
            id: this.editForm.id,
            policyholder: this.editForm.policyholder.trim(),
            beneficiary: this.editForm.beneficiary.trim(),
            track_no: this.editForm.track_no.trim(),
            plate_no: this.editForm.plate_no.trim(),
            cargo_name: this.editForm.cargo_name.trim(),
            quantity: this.editForm.quantity.trim(),
            beginning: this.editForm.beginning.trim(),
            destination: this.editForm.destination.trim(),
            created_at: Math.floor(this.editForm.created_at / 1000),
            effected_at: Math.floor(this.editForm.effected_at / 1000),
            expired_at: Math.floor(this.editForm.expired_at / 1000)
          })
          if (response && response.err_code === 0) {
            if (response.data && response.data.updated === false) {
              this.$message.info('订单信息未发生变化')
            } else {
              this.$message.success('订单信息修改成功，已向保险公司发送报备邮件')
            }
            this.editDialogVisible = false
            if (!response.data || response.data.updated !== false) {
              await this.loadData()
            }
          }
        } catch (error) {
          console.error('修改订单信息失败：', error)
          this.$message.error('修改订单信息失败')
        } finally {
          this.editSubmitting = false
        }
      })
    },
    async handleDelete(row) {
      try {
        await this.$confirm(`确认删除保单号为 ${row.policyNo} 的订单吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        this.loading = true
        
        // 调用删除API
        const response = await deleteHyxOrder({ id: row.id })
        
        if (response.data && response.data.code === 200) {
          this.$message.success('删除成功')
          // 重新加载数据
          await this.loadData()
        } else {
          this.$message.error('删除失败：' + (response.data && response.data.message ? response.data.message : '未知错误'))
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除失败：', error)
          this.$message.error('删除失败：' + error.message)
        }
      } finally {
        this.loading = false
      }
    },
    getStatusType(status) {
      const statusMap = {
        1: 'warning',    // 未支付
        4: 'success',    // 已支付
        2: 'danger',     // 已取消
        64: 'danger'     // 已取消
      }
      return statusMap[status] || 'info'
    },
    getStatusText(status) {
      const statusMap = {
        1: '未支付',
        4: '已支付',
        2: '已取消',
        64: '已取消'
      }
      return statusMap[status] || '未知'
    },
    formatMoney(amount) {
      if (!amount) return '0.00'
      return parseFloat(amount).toFixed(2)
    },
    formatPayType(payType) {
      const payTypeMap = {
        1: '余额支付',
        32: '鼎盛余额支付'
      }
      return payTypeMap[payType] || '未知'
    },
    formatInvoiceStatus(status) {
      const statusMap = {
        1: '未打印',
        2: '处理中',
        4: '已打印'
      }
      return statusMap[status] || '未知'
    },
    formatOrderSource(source) {
      const sourceMap = {
        1: 'PC端',
        2: '移动端',
        4: 'iOS端',
        8: '安卓端',
        16: 'API',
        32: '微信小程序',
        64: '渠道后台',
        128: '内部后台',
        256: '代理人H5',
        512: '代客投保'
      }
      return sourceMap[source] || '未知'
    },
    formatInsuranceType(insuranceType) {
      if (!insuranceType) {
        return '未选择'
      }
      const company = this.insuranceCompanyList.find(item => item.id === insuranceType)
      return company ? company.name : '未知保险公司'
    },
    getOrderFiles(fileUrl) {
      if (Array.isArray(fileUrl)) {
        return fileUrl.filter(item => typeof item === 'string' && item.trim())
      }
      if (typeof fileUrl !== 'string' || !fileUrl.trim()) {
        return []
      }
      try {
        const parsed = JSON.parse(fileUrl)
        if (Array.isArray(parsed)) {
          return parsed.filter(item => typeof item === 'string' && item.trim())
        }
      } catch (error) {
        // 单个文件地址不是 JSON 时直接作为一项展示
      }
      return [fileUrl]
    },
    getFileName(fileUrl, index) {
      const path = fileUrl.split('?')[0]
      const fileName = path.substring(path.lastIndexOf('/') + 1)
      if (!fileName) return `订单文件${index + 1}`
      try {
        return decodeURIComponent(fileName)
      } catch (error) {
        return fileName
      }
    },
    formatDate(date) {
      if (date === undefined || date === null || date === '') {
        return ''
      }
      
      let timestamp
      
      // 处理对象类型（可能包含时间戳）
      if (typeof date === 'object' && date !== null) {
        if (date.time) {
          timestamp = date.time
        } else if (date.timestamp) {
          timestamp = date.timestamp
        } else {
          return ''
        }
      }
      // 处理数字类型（时间戳）
      else if (typeof date === 'number') {
        timestamp = date
      }
      // 处理字符串类型
      else if (typeof date === 'string') {
        // 如果是纯数字字符串，当作时间戳处理
        if (/^\d+$/.test(date)) {
          timestamp = parseInt(date)
        } else {
          // 尝试解析日期字符串
          const parsedDate = new Date(date)
          if (isNaN(parsedDate.getTime())) {
            return ''
          }
          timestamp = parsedDate.getTime()
        }
      } else {
        return ''
      }
      
      // 确保时间戳是毫秒级别的
      if (timestamp < 10000000000) {
        timestamp = timestamp * 1000
      }
      
      const dateObj = new Date(timestamp)
      
      // 检查日期是否有效
      if (isNaN(dateObj.getTime())) {
        return ''
      }
      
      // 格式化为 YYYY-MM-DD HH:mm:ss
      const year = dateObj.getFullYear()
      const month = String(dateObj.getMonth() + 1).padStart(2, '0')
      const day = String(dateObj.getDate()).padStart(2, '0')
      const hours = String(dateObj.getHours()).padStart(2, '0')
      const minutes = String(dateObj.getMinutes()).padStart(2, '0')
      const seconds = String(dateObj.getSeconds()).padStart(2, '0')
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    
    // 电子保单相关方法
    needApiPolicy(insuranceType) {
      // 根据旧项目的逻辑，人保160和太平洋144需要通过API获取保单
      return insuranceType === 160 || insuranceType === 144
    },
    
    downloadPolicy(orderId, insuranceType) {
      try {
        // 根据旧项目的逻辑构建下载URL
        let baseUrl = ''
        
        // 判断环境（这里需要根据实际项目配置调整）
        const isProduction = process.env.NODE_ENV === 'production'
        
        if (isProduction) {
          // 生产环境URL
          baseUrl = 'https://api.example.com'
        } else {
          // 测试环境URL
          baseUrl = 'https://test-api.example.com'
        }
        
        // 构建完整的下载URL
        const downloadUrl = `${baseUrl}/policy/download?order_id=${orderId}&insurance_type=${insuranceType}`
        
        // 在新窗口打开下载链接
        window.open(downloadUrl, '_blank')
        
        this.$message.success('正在生成保单下载链接...')
      } catch (error) {
        console.error('下载保单失败:', error)
        this.$message.error('下载保单失败，请重试')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.appointment-freight-all-orders {
  padding: 20px;

  .search-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px;
    flex-wrap: wrap;
  }

  .search-form {
    flex: 1;
    margin-bottom: 20px;
  }

  .search-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .search-summary {
    display: flex;
    align-items: center;
    gap: 15px;
  }

  .premium-total {
    font-size: 16px;
    color: #333;
  }
  
  .pagination-wrapper {
    margin-top: 20px;
    text-align: right;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both;
  }

  /* 表格样式优化 */
  .el-table {
    font-size: 12px;

    th {
      background-color: #f5f7fa;
      font-weight: bold;
    }

    td {
      padding: 8px 0;
    }
  }

  /* 搜索表单样式 */
  .el-form-item {
    margin-bottom: 10px;

    .el-form-item__label {
      font-weight: bold;
      color: #333;
    }
  }

  /* 对话框样式 */
  .el-descriptions {
    margin-top: 20px;

    .el-descriptions-item__label {
      font-weight: bold;
      background-color: #f5f7fa;
    }
  }

  /* 订单详情对话框样式 */
  .order-detail-content {
    padding: 10px;
  }

  .detail-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
  }

  .detail-table tr {
    height: 35px;
  }

  .detail-table td {
    line-height: 26px;
    padding: 8px 12px;
    border-bottom: 1px solid #f0f0f0;
  }

  .detail-table .label {
    font-weight: bold;
    text-align: right;
    width: 120px;
    color: #606266;
    background-color: #fafafa;
  }

  .detail-table .value {
    color: #303133;
    width: 200px;
  }

  /* 重要信息高亮 */
  .detail-table .value.highlight {
    color: #e6a23c;
    font-weight: 600;
  }

  /* 金额样式 */
  .detail-table .value.price {
    color: #f56c6c;
    font-weight: 600;
    font-family: 'Courier New', monospace;
  }

  /* 状态标签 */
  .status-tag {
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    background-color: #f0f9ff;
    color: #1890ff;
    border: 1px solid #d6f7ff;
  }

  .status-tag.success {
    background-color: #f6ffed;
    color: #52c41a;
    border-color: #b7eb8f;
  }

  .status-tag.warning {
    background-color: #fffbe6;
    color: #faad14;
    border-color: #ffe58f;
  }

  .status-tag.danger {
    background-color: #fff2f0;
    color: #ff4d4f;
    border-color: #ffccc7;
  }

  .status-tag.info {
    background-color: #f0f9ff;
    color: #1890ff;
    border-color: #d6f7ff;
  }

  .dialog-footer {
    text-align: center;
    padding: 16px 0;
  }

  /* 电子保单样式 */
  .policy-link {
    color: #1890ff;
    text-decoration: underline;
    cursor: pointer;
  }
  
  .policy-link:hover {
    color: #40a9ff;
  }
  
  .no-policy {
    color: #999;
    font-style: italic;
  }

  .order-file-item {
    display: flex;
    align-items: center;
    gap: 10px;
    line-height: 24px;
  }

  .order-file-name {
    overflow-wrap: anywhere;
  }
  
  /* 响应式布局 */
  @media (max-width: 1200px) {
    .search-toolbar {
      flex-direction: column;
      align-items: stretch;
    }
    
  }

  @media (max-width: 768px) {
    padding: 10px;

    .search-actions {
      align-items: flex-start;
      gap: 12px;
    }

    .search-summary {
      justify-content: flex-end;
      flex-wrap: wrap;
    }
  }
}
</style>
